import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Card } from '../../../card-container/card/card';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ClassroomTerm } from '../../../../../classroom360/classroom-summary/models/classroom-term.model';
import { ClassroomSummaryService } from '../../../../../classroom360/classroom-summary/classroom-summary.service';
import { CourseSchedule } from '../../../../../shared-components/student/course-schedule.model';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { Student } from '../../../../../shared-components/student/student.model';
import { YearService } from '../../../../../shared-components/year/year.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-staff-student-schedule-card',
    templateUrl: './staff-student-schedule-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./staff-student-schedule-card.component.css']
})
export class StaffStudentScheduleCardComponent implements OnInit, OnDestroy {

    @Input() data: any;
    termOptions: ClassroomTerm[];
    subscriptions: Subscription[] = [];
    card: Card;
    showDropped = false;
    // Angular Material Table
    displayedColumns: string[] = ['Meets', 'Term', 'CourseName', 'CourseSection', 'EntryDate', 'DroppedDate'];
    selectedTermId: number;
    studentSchedules: CourseSchedule[] = [];
    studentSchedule: CourseSchedule[] = [];
    constructor(
        private studentService: StudentService,
        private yearService: YearService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private classroomSummaryService: ClassroomSummaryService
    ) { }

    ngOnInit() {
        this.selectedTermId = 0;
        this.termOptions = this.classroomSummaryService.terms;
        this.card = this.data;
        this.getStudentSchedule();
    }

    getStudentSchedule() {
        this.studentSchedules = [];
        let viewOption = 3;
        let termId = 0;
        let nextSchoolDay = false;
        if (this.selectedTermId == -1) {  // Today
            viewOption = 1;
        } else if (this.selectedTermId == -2) { // Next School day
            viewOption = 2;
            nextSchoolDay = true;
        } else if (this.selectedTermId == -3) {  // This Week
            viewOption = 2;
        } else if (this.selectedTermId == 0) { // All Term
            viewOption = 3;
        } else if (this.selectedTermId > 0) { // Selected term
            viewOption = 3;
            termId = this.selectedTermId;
        }

        this.studentService.getStudentSchedule(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id, viewOption, undefined, undefined, true, true, true, undefined, termId, nextSchoolDay).subscribe(data => {
            this.studentSchedules = data;
            if (!this.showDropped) {
                this.studentSchedule = this.studentSchedules.filter(ar => ar.DroppedDate.toString() == '0001-01-01T00:00:00');
            } else {
                this.studentSchedule = _.cloneDeep(this.studentSchedules);
            }
            this.updateView();
        });
    }

    termChange() {
        this.getStudentSchedule();
    }


    ngOnDestroy() {
    }

    goToStudentSchedule() {
        this.router.navigateByUrl('/student360/schedule?studentPortal=true');
    }

    hideShowDropped() {
        if (!this.showDropped) {
            this.studentSchedule = this.studentSchedules.filter(ar => ar.DroppedDate.toString() == '0001-01-01T00:00:00');
        } else {
            this.studentSchedule = _.cloneDeep(this.studentSchedules);
        }
        this.updateView();
    }

    updateView() {
        this.cdr.detectChanges();
    }

}
